export default __webpack_public_path__ + "static/media/head01_ko_sp.25c17104.png";